<!--
 * @Author: Src
 * @Date: 2026-02-27 17:20:54
 * @LastEditTime: 2026-03-09 19:17:06
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/appslider/index.vue
 * @Description: 头部注释配置模板
-->
<template>
  <div class="captcha_class">
    <div v-if="type == 'popup'" class="captchaTitle">请完成安全验证</div>
    <div id="captcha-element"></div>
    <!-- <button id="captcha-button" @click="callbackApp(s_t)">点击弹出</button> -->
  </div>
</template>

<script lang='ts'>
import { Vue, Component, Watch } from 'vue-property-decorator';
@Component
export default class AppSlider extends Vue {
  captcha: any = null;
  captchaButton: any = null;

  mounted() {
    this.captchaButton = document.getElementById('captcha-button');
    this.getRoute();
    this.initCaptcha();

  }
  initCaptcha() {
    window.initAliyunCaptcha({
      SceneId: '1baopk3f', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      mode: 'embed', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      // button: '#captcha-button', // 触发验证码弹窗的元素。
      success: this.success,
      rem: 0.9, // 验证码是否自适应屏幕大小，无需修改
      fail: this.fail,
      getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
      slideStyle: {
        width: 300,
        height: 45,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    });
  }

  type: any = '';

  @Watch('$route')
  getRoute() {
    // const { path } = this.$route;
    const { type } = this.$route.query;
    this.type = type;
    this.myMethod();
  }

  sendToApp: any;
  callbackApp(t: string) {
    window.uni.postMessage({ data: t });
  }

  myMethod() {
    this.initCaptcha();
  }

  getInstance(instance: any) {
    this.captcha = instance;
  }
  success(captchaVerifyParam: any) {
    // 入参为验签captchaVerifyParam
    // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
    // 2.根据校验结果来进行业务处理
    // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
    this.callbackApp(captchaVerifyParam);
  }
  // 验证码验证不通过回调函数
  fail(error: any) {
    console.error(error);
  }
}
</script>
<style scoped lang='scss'>
.captchaTitle {
  font-size: 16px;
  color: #333;
  padding-bottom: 10px;
  box-sizing: border-box;
}
.captcha_class {
  margin: 10px 20px;
  background-color: transparent;
}
</style>
